export default __webpack_public_path__ + "static/media/Meditation Rod.9bc31a7d.jpg";